import React from "react";
import { ShieldCheck } from "lucide-react";

const YEAR = new Date().getFullYear();

export const LegalFooter = ({ compact = false }) => (
  <footer data-testid="legal-footer" className={`relative z-10 border-t border-slate-800/80 ${compact ? "mt-8 pt-5" : "mt-10 py-6"}`}>
    <div className={`mx-auto max-w-7xl px-4 text-center sm:px-6 lg:px-8 ${compact ? "" : "flex flex-col items-center gap-2"}`}>
      <p data-testid="legal-footer-copyright" className="text-[11px] font-medium tracking-wide text-slate-400">
        © {YEAR} ADMIN THIS N THATZ SYNCD LLC. All rights reserved.
      </p>
      <p data-testid="legal-footer-trademarks" className="mt-1 text-[11px] leading-relaxed text-slate-500">
        R.U.A.C.H.™ and Total eXchange Validation™ are trademarks of ADMIN THIS N THATZ SYNCD LLC.
        Software system and method are U.S. Patent Pending.
      </p>
      {!compact && (
        <p className="mt-1 flex items-center justify-center gap-1.5 text-[10px] text-slate-600">
          <ShieldCheck className="h-3 w-3 text-emerald-500/80" /> Each company's data is isolated and encrypted in transit. Unauthorized access, copying or
          reverse engineering is prohibited.
        </p>
      )}
    </div>
  </footer>
);

export default LegalFooter;
